import React, {PropsWithChildren} from 'react';
import RadioButton from '../../../../incase-domain/components/radioButton/RadioButton';

interface ProtectionOptionsFormWrapperProps {
    label: string;
    checked: boolean;
    onToggle: () => void;
}

function ProtectionOptionsFormWrapper({
    label,
    checked,
    onToggle,
    children,
}: PropsWithChildren<ProtectionOptionsFormWrapperProps>): JSX.Element {
    return (
        <div className="c-protectionOptionsFormWrapper u-flex u-gap-2 u-w-full u-h-between u-v-center">
            <RadioButton size="sm" enableHover label={label} active={checked} onClick={onToggle} />

            {checked && <div className="c-protectionOptionsFormWrapper__children u-flex u-gap-1 u-v-center">{children}</div>}
        </div>
    );
}

export default ProtectionOptionsFormWrapper;
